/** XeAgents.ai**/
import { motion } from "framer-motion";
import { TabConfig } from "./useCaseData";

interface TabButtonProps {
  tab: TabConfig;
  isActive: boolean;
  onClick: () => void;
}

export function TabButton({ tab, isActive, onClick }: TabButtonProps) {
  return (
    <button
      id={`tab-button-${tab.id}`}
      role="tab"
      aria-selected={isActive}
      aria-controls={`agent-grid-${tab.id}`}
      onClick={onClick}
      className={`relative flex items-center gap-2.5 py-2.5 px-5 sm:px-6 rounded-full transition-all duration-300 text-sm sm:text-base font-medium ${
        isActive
          ? "text-white"
          : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800/50"
      }`}
      data-testid={`tab-button-${tab.id}`}
    >
      {isActive && (
        <motion.div
          layoutId="activeUseCaseTab"
          className="absolute inset-0 bg-gradient-to-r from-violet-600 to-indigo-600 rounded-full shadow-lg shadow-violet-500/25"
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 30,
          }}
        />
      )}
      <span className="relative z-10 flex items-center gap-2">
        <span
          className={`w-1.5 h-1.5 rounded-full transition-colors duration-300 ${
            isActive
              ? "bg-white"
              : "bg-slate-300 dark:bg-slate-600"
          }`}
        />
        {tab.label}
      </span>
    </button>
  );
}